import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutClaimsDetail } from "./autogen/AutogenLayoutClaimsDetail";

export class ClaimsDetail extends AutogenLayoutClaimsDetail {
    textboxClaimReasonCodesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }

    textboxOrderTypeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }
}